<template>
  <div>
    <h1>TREATMENT SUBGOALS</h1>
    <v-layout>
      <v-text-field v-model="name" solo label="Name"></v-text-field>
      <v-select label="Goal" v-model="id_goal" :items="goals" item-text="name" item-value="id" solo multiple chips></v-select>
      <v-btn :disabled="(name != null && name != '') && (id_goal != null && id_goal != '') ? false : true" @click="createSubGoal" text
        color="success">add new subgoal</v-btn>
    </v-layout>
    <v-layout>
      <v-text-field @input="seatchMethod" v-model="search" solo label="Search"></v-text-field>
    </v-layout>
    <v-layout v-if="subgoals != null">
      <v-data-table v-if="subgoals.length" :headers="[
        /* { text: 'NUMBER', value: 'id_playlist' }, */
        { text: 'ID', value: 'id' },
        { text: 'NAME', value: 'name' },
        { text: 'Order', value: 'index_order' },
        { text: 'GOAL', value: 'goals' },
        { text: 'EDIT', value: 'edit' },
        { text: 'DELETE', value: 'actions' },

      ]" :items="filteredSubGoals">
        <template v-slot:item.actions="{ item }">
          <v-btn @click="deleteItem(item)" text color="error">DELETE</v-btn>
        </template>
        <template v-slot:item.goals="{ item }">
          {{ findGoalById(item.id_goal) }}
        </template>
        <template v-slot:item.edit="{ item }">
          <v-btn @click="edit(item)" text color="info">Edit</v-btn>
        </template>
      </v-data-table>
      <v-dialog v-model="dialog" v-if="selected != null" width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            Updating
          </v-card-title>

          <v-card-text>
            <v-text-field v-model="selected.name" label="Name"></v-text-field>
            <v-card-text>
              <v-text-field v-model="selected.index_order" label="Order"></v-text-field>
            </v-card-text>
            <v-select label="Goal" v-model="selected.id_goal" chips :items="goals" item-text="name" item-value="id" solo
              multiple></v-select>
          </v-card-text>

          <v-divider></v-divider>


          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" flat @click="update">
              Update
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios';

export default {
  data() {
    return {
      name: null,
      id_goal: null,
      subgoals: null,
      goals:null,
      filteredSubGoals: null,
      search: '',
      dialog: false,
      selected: null,
    }
  },
  methods: {
    async update() {
      if (this.selected.name != null && this.selected.name != "")
        await axios
          .post("/admin/treatment/updateSubGoal", {
            id: this.selected.id,
            name: this.selected.name,
            id_goal: this.selected.id_goal,
            index_order: this.selected.index_order,
          }).then(() => {
            this.sync();
            // this.selected.name = null;
            // this.selected.id_goal =null;
            // this.selected.id = null,
            this.dialog = false;
          })
    },
    edit(item) {
      this.selected = Object.assign({}, item);
      this.dialog = true;
    },
    seatchMethod(val) {
      if (this.search == '') {
        this.filteredSubGoals = this.subgoals.sort((a, b) => {
          const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
          const nameB = b.name.toUpperCase();

          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }
          return 0; // Names are equal
        });
        ;;
      }
      else {
        this.filteredSubGoals = this.subgoals.filter(element => {
          return (element.name).includes(this.search)
        });
      }
    },
    findGoalById(ids) {
      if(this.goals!=null) {
        if (Array.isArray(ids) && ids.length > 0) {
            const goals = this.goals.filter(goal => ids.includes(goal.id)); // Преобразуем id в строку для корректного сравнения
            return goals.length > 0 ? goals.map(goal => goal.name).join(', ') : 'Goal not found';
        }
      }
    },
    async createSubGoal() {
      if (this.name != null && this.name != "")
        await axios
          .post("/admin/treatment/createSubGoal", {
            name: this.name,
            id_goal: this.id_goal
          }).then(() => {
            this.sync();
            this.name = null;
            this.id_goal = null;
          })
    },
    async deleteItem(item) {
      await axios
        .post("/admin/treatment/deleteSubGoals", item).then(() => {
          this.sync();
        })
    },
    async sync() {
      await axios
        .get("/admin/treatment/getSubGoals").then((res) => {
          this.subgoals = res.data.sort((a, b) => {
            const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
            const nameB = b.name.toUpperCase();

            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0; // Names are equal
          });
          ;;
          this.filteredSubGoals = res.data.sort((a, b) => {
            const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
            const nameB = b.name.toUpperCase();

            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0; // Names are equal
          });
          ;;
        });
      await axios
        .get("/admin/treatment/getGoals").then((res) => {
          this.goals = res.data.sort((a, b) => {
            const nameA = a.name.toUpperCase(); // Convert names to uppercase for case-insensitive sorting
            const nameB = b.name.toUpperCase();

            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0; // Names are equal
          });
        })


    },
  },
  async created() {
    await this.sync();
  }
}
</script>
<style lang="scss" scoped></style>